<style lang="less" rel="stylesheet/less" type="text/less">
     .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
	<div>
		<Table
			:columns="titleNot"
			:data="data_1"
			:show-header="false"
			border/>
			<!-- <Row>
			<Col span="24">
			<span class="expand-key">Favorite book: </span>
			<span class="expand-value">《{{ row.book }}》</span>
            </Col>
			<Col span="24">
			<span class="expand-key">Favorite movie: </span>
			<span class="expand-value">{{ row.remark }}</span>
            </Col>
			<Col span="24">
			<span class="expand-key">Favorite music: </span>
			<span class="expand-value">{{ row.music }}</span>
            </Col>
		</!-->
	</div>
</template>
<script>
export default {
	props: {
		row: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			titleNot: [],
			data_1:null,
		};
	},
	created() {
		// this.row = JSON.parse(this.row.prices);
		// console.log(this.row);
        this.data_1=this.row

	},
};
</script>
